import React, { lazy, Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import { createBrowserRouter } from "react-router-dom";
import MastersPolpaico from "../Screens/MastersPolpaico";

const Inland = lazy(() => import("../Screens/Inland"));
const SU = lazy(() => import("../Screens/SecurityUnion"));
const GO = lazy(() => import("../Screens/GOCoach"));
const Sports = lazy(() => import("../Screens/GOClient"));
const DoctorMeet = lazy(() => import("../Screens/DoctorMeet"));
const Error = lazy(() => import("../Screens/Error"));
const LET = lazy(() => import("../Screens/Let"));
const LETInspectors = lazy(() => import("../Screens/LetInspectors"));
const Hexacore = lazy(() => import("../Screens/Hexacore"));
const Plat = lazy(() => import("../Screens/Plat"));
const GaliRend = lazy(() => import("../Screens/GaliRend"));

const CustomLoader = ({ text }: { text: string }) => (
  <Box
    flexDirection={"column"}
    justifyContent={"center"}
    alignItems={"center"}
    flex={1}
  >
    <CircularProgress color="secondary" />
    <h3 style={{ textAlign: "center" }}>{text}</h3>
  </Box>
);

const errorElement = (
  <Suspense fallback={<CircularProgress color="secondary" />}>
    <Error />
  </Suspense>
);

const Routes = createBrowserRouter([
  {
    path: "/inland",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <Inland />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/securityunion",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <SU />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/gocoach",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <GO />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/gosports",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <Sports />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/doctormeet",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <DoctorMeet />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/hexacore",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <Hexacore />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/letinspectors",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <LETInspectors />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/plat",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <Plat />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/let",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <LET />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/galilea",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <GaliRend />
      </Suspense>
    ),
    errorElement,
  },
  {
    path: "/masterspolpaico",
    element: (
      <Suspense fallback={<CustomLoader text="Cargando..." />}>
        <MastersPolpaico />
      </Suspense>
    ),
    errorElement,
  },
]);

export default Routes;
